export const ALERT_SUCCESS = 'success'
export const ALERT_DANGER = 'danger'
export const ALERT_WARNING = 'warning'